<template>
    <div>
        <section class="content-header">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-12">
                        <h3>{{ $t('label.application') }}</h3>
                    </div>
                    <div class="col-md-12">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><router-link to="/">{{ $t("label.home")}}</router-link></li>
                            <li class="breadcrumb-item"><router-link to="/application">{{ $t("label.application")}}</router-link></li>
                            <li class="breadcrumb-item active">{{ $t("label.scan")}}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </section>

        <div class="content">
            <div class="container-fluid">
				<div class="col-md-12">
					<div class="card card-success card-outline">
						<div class="card-header px-2">
							<h3 class="card-title">{{ $t("label.scan")}}</h3>
							<!-- <div class="card-tools">
								<button type="button" class="btn btn-tool" data-widget="collapse" :title="$t('label.collapse')">
									<fa :icon="fas.faMinus"/>
								</button>
							</div> -->
						</div>
						<div class="card-body">
							<div v-if="$hasPermission('tempvehicle.application.view')" class="input-group">
								<input type="text" class="form-control" id="scan" v-model="uuid" v-on:keyup.enter="viewApplication" autofocus>
								<button class="btn btn-sm btn-primary" @click="OpenQRModal">Open Camera</button>
							</div>
							<!-- <div class="input-group align-center">
								<button class="btn btn-sm btn-primary mt-2" @click="OpenQRModal">Open Camera</button>
							</div> -->
						</div>	
					</div>
				</div>	
            </div>
        </div>
		<div class="modal" tabindex="-1" role="dialog" id="QRModal" data-keyboard="false" data-backdrop="static">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<button type="button" class="close" @click="modalClose" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div id="loadingMessage">
							🎥 Unable to access video stream (please make sure you have a webcam enabled)
						</div>
						<canvas id="canvas" width="200" height="200"></canvas>
						<div id="output" hidden>
							<div id="outputMessage">No QR code detected.</div>
							<div hidden>
							<b>Data:</b>
							<span id="outputData"></span>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" @click="modalClose">Close</button>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>
<script type="module">
import { fas } from "@fortawesome/free-solid-svg-icons";
// import QrScanner from 'qr-scanner';
import jsQR from "jsqr";
export default {
	name: 'Scan',
	data() {
		return {
			baseURI: "",
			uuid: '',
			video: null,
		}
	},
	mounted() {
		// $('#scan').focus();
		this.qrCode();
	},
	computed:{
		fas() {
            return fas;
		}		
	},
	methods: {
		modalClose(){
			try {
				const mediaStream = this.video.srcObject;
				const tracks = mediaStream.getTracks();
				tracks.forEach(track => track.stop());
				// tracks[0].stop();
				$('#QRModal').modal('hide');
			}catch(err){
				$('#QRModal').modal('hide');
			}
		},
		qrCode: function(){
			let that = this;
			$('#QRModal').on('shown.bs.modal', function (){
				that.video = document.createElement("video");
				var canvasElement = document.getElementById("canvas");
				var canvas = canvasElement.getContext("2d");
				var loadingMessage = document.getElementById("loadingMessage");
				var outputContainer = document.getElementById("output");
				var outputMessage = document.getElementById("outputMessage");
				var outputData = document.getElementById("outputData");

				function drawLine(begin, end, color) {
					canvas.beginPath();
					canvas.moveTo(begin.x, begin.y);   
					canvas.lineTo(end.x, end.y);
					canvas.lineWidth = 4;
					canvas.strokeStyle = color;
					canvas.stroke();
				}

				navigator.mediaDevices
				.getUserMedia({ video: { facingMode: "environment" } })
				.then(function(stream) {
					that.video.srcObject = stream;
					that.video.setAttribute("playsinline", true);
					that.video.play();
					requestAnimationFrame(tick);
				});

				function tick() {
					loadingMessage.innerText = "⌛ Loading video...";
					if (that.video.readyState === that.video.HAVE_ENOUGH_DATA) {
						loadingMessage.hidden = true;
						canvasElement.hidden = false;
						outputContainer.hidden = false;

						canvasElement.height = 340;
						canvasElement.width = 465;
						canvas.drawImage(that.video,0,0,canvasElement.width,canvasElement.height);
						var imageData = canvas.getImageData(0,0,canvasElement.width,canvasElement.height);
						var code = jsQR(imageData.data, imageData.width, imageData.height, {inversionAttempts: "invertFirst"});
						if (code) {
							drawLine(
								code.location.topLeftCorner,
								code.location.topRightCorner,
								"#FF3B58"
							);
							drawLine(
								code.location.topRightCorner,
								code.location.bottomRightCorner,
								"#FF3B58"
							);
							drawLine(
								code.location.bottomRightCorner,
								code.location.bottomLeftCorner,
								"#FF3B58"
							);
							drawLine(
								code.location.bottomLeftCorner,
								code.location.topLeftCorner,
								"#FF3B58"
							);
							outputMessage.hidden = true;
							outputData.parentElement.hidden = false;
							outputData.innerText = code.data;
							if(that.uuid != code.data){
								that.uuid = code.data;
								that.viewApplication();
							}
						} else {
							outputMessage.hidden = false;
							outputData.parentElement.hidden = true;
						}
					}
					requestAnimationFrame(tick);
				}
			});
		},
		viewApplication(){
			if(this.uuid.trim() != '' && !this.found){
				// this.$store.state.loading.status = true;
				let that = this;
				let url = this.baseURI+'/applications/'+this.uuid;
				GDCE_Client.requestApi("GET", url).then(response => {
					this.modalClose();
					if(response.status && response.data != null) {
						this.declaration = response.data;
						let routeData = this.$router.resolve({name: 'ViewApplication', params: {uuid: this.uuid}}); 
						setTimeout(function(){
							that.uuid = '';
						}, 1000);         
						window.open(routeData.href, '_blank');
					}else{
						that.uuid = '';
						this.$swal({
                            title: this.$t('label.search_not_found'),
                            icon: "error",
							confirmButtonClass: "btn-danger",
							confirmButtonText: this.$t('label.close'),
                        })
					}
					// this.$store.state.loading.status = false;
				}).catch(error => {
					// this.$store.state.loading.status = false;
				});
			}            
		},

		OpenQRModal: function () {
			$("#QRModal").modal("show");
		}
	}
}
</script>
